import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { DeskPool } from '../../DeskPool';
import { getDuration } from '../../../../api';
import { selectMatchState } from '../../../../store/match';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { VoteTarget } from '../../../molecules/VoteTarget/VoteTarget';
export function Vote() {
    var _a, _b;
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const [vote, setVote] = useState(false);
    const [voteDuration, setVoteDuration] = useState({ minutes: '00', seconds: '00' });
    const [isVoting, setIsVoting] = useState(false);
    useEffect(() => {
        const interval = setInterval(() => {
            var _a;
            setVoteDuration(getDuration(((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.startsAt) || 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [matchState]);
    const currentVoteId = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.voteId) || '';
    const currentPlayer = (_b = matchState === null || matchState === void 0 ? void 0 : matchState.players) === null || _b === void 0 ? void 0 : _b.find((p) => { var _a; return p.id === ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer); });
    const onVote = () => {
        setVote(true);
    };
    const resetVote = () => {
        setVote(false);
    };
    const gameButtonState = {
        text: isVoting ? 'Выполняется...' : 'отдать голос',
        visible: true,
        onClick: onVote,
        addOnText: voteDuration,
        disabled: isVoting,
    };
    const getAddOnComponent = ({ player, onClose }) => (_jsx(VoteTarget, { resetVote: resetVote, vote: vote, votingPlayer: currentPlayer, player: player, onClose: onClose, onVotingStateChange: setIsVoting }));
    return _jsx(DeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState, addOnComponent: getAddOnComponent });
}
